import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-view-documents',
  templateUrl: './view-documents.component.html',
  styleUrls: ['./view-documents.component.css']
})
export class ViewDocumentsComponent implements OnInit {
  url;
  urlGoogleViewer: string = "https://drive.google.com/viewerng/viewer?url=";
  loading: boolean = true;
  constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef, protected _sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.url = this._sanitizer.bypassSecurityTrustResourceUrl(this.config.data.url);
    this.loading = false;
  }
  
  close(){
    this.ref.close();
  }
}
